import { usePublicClient } from 'wagmi';
import QuoterAbi from '@/infrastructure/abis/UniswapQuoterV2Abi';
import { getChainConstant } from '@/domain/chain';
import useChainId from '@/hooks/useChainId';
import { Addresses } from '@/domain/addresses';
import { useQuery } from '@tanstack/react-query';

const useFloorMarketPrice = () => {
  const chainId = useChainId();

  const client = usePublicClient();
  return useQuery({
    queryKey: ['floorPrice', chainId],
    queryFn: async () => {
      const call = await client?.simulateContract({
        abi: QuoterAbi,
        address: getChainConstant(Addresses, chainId, 'UniswapQuoter'),
        functionName: 'quoteExactOutputSingle',
        args: [
          {
            amount: BigInt(1e18),
            fee: 10000,
            sqrtPriceLimitX96: 0n,
            tokenIn: getChainConstant(Addresses, chainId, 'WETH'),
            tokenOut: getChainConstant(Addresses, chainId, 'FloorToken'),
          },
        ],
      });

      return call?.result[0];
    },
    gcTime: 15000,
    enabled: !!client,
  });
};

export default useFloorMarketPrice;
